/**
 * @description: 平板点歌app设置
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="pad-order-set">
        <ul class="row list-tit" v-show="titShow">
            <li class="col-md-3" v-for="menuItem in menu" :key="menuItem.id"><span class="col-md-10" @click="titClk(menuItem.id)">{{menuItem.name}}</span></li>
        </ul>
        <div class="list-con">
            <div v-show="listShow1">
                <div class="dtj-list" v-show="showDtjList">
                    <el-row>
                        <el-button @click="backFun">返回</el-button>
                    </el-row>
                    <h1 class="pos-title">超市点单推荐设置</h1>
                    <el-form :inline="true" :model="dtj_list_form">
                        <el-form-item label="门店">
                            <el-select v-model="dtj_list_form.shop_id" filterable placeholder="请选择门店">
                                <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="pull-right">
                            <el-button type="primary" @click="dtjTable(1)">查询</el-button>
                            <el-button type="primary" @click="dtjAdd">新增推荐</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table
                        v-loading="loading"
                        element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)"
                        :data="dtj_table">
                        <el-table-column prop="shop_name" label="适用门店"></el-table-column>
                        <el-table-column prop="listorder" label="优先级"></el-table-column>
                        <el-table-column prop="room_names" label="适用包厢"></el-table-column>
                        <el-table-column label="适用日期">
                            <template slot-scope="scope">
                                {{scope.row.use_every_day == '1' ? '每天' : scope.row.start_date + '~' + scope.row.end_date}}
                            </template>
                        </el-table-column>
                        <el-table-column label="适用时间段">
                            <template slot-scope="scope">
                                {{scope.row.start_time + '~' + scope.row.end_time}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="week_cycle_str" label="有效星期几"></el-table-column>
                        <el-table-column prop="goods_num" label="图片"></el-table-column>
                        <el-table-column label="状态">
                            <template slot-scope="scope">
                                {{scope.row.status == '1' ? '启用' : '禁用'}}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="dtjModify(scope.row.id)">修改</span>
                                <span class="text-blue" @click="dtjDel(scope.row.id)">删除</span>
                                <span class="text-blue" @click="dtjStatus(scope.row)">{{scope.row.status == '1' ? '禁用' : '启用'}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        background
                        layout="total, prev, pager, next, jumper"
                        :page-size="GLOBAL.PAGESIZE"
                        :current-page.sync="dtj_page"
                        :total="dtj_total"
                        @current-change="dtjTable">
                    </el-pagination>
                </div>
                <div class="dtj-edit" v-show="showDtjEdit">
                    <h2>{{dtj_edit_tit}}</h2>
                    <el-form :model="dtj_edit_form" label-width="120px">
                        <el-form-item label="门店">
                            <el-select v-model="dtj_edit_form.shop_id" filterable placeholder="请选择门店" @change="dtjShopChange">
                                <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="优先级">
                            <el-input placeholder="请输入规则优先级，数值大的优先" v-model="dtj_edit_form.listorder"></el-input>
                        </el-form-item>
                        <el-form-item label="适用包厢">
                            <el-input v-model="dtj_room_txt" class="el-ellipsis" clearable placeholder="请选择包厢号" @focus="dtjRoomSelect" @clear="dtjRoomDel"></el-input>
                        </el-form-item>
                        <el-form-item label="适用日期" class="dtj-usedate-wrap">
                            <div ref="dtj_usedate_main" class="dtj-usedate-main">
                                <el-input v-model="dtj_usedate_txt" class="el-ellipsis" placeholder="请选择适用日期"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item label="适用时间段">
                            <el-input v-model="dtj_usetime_txt" class="el-ellipsis" placeholder="请选择适用时间" @click.native="dtjUsetime"></el-input>
                        </el-form-item>
                        <el-form-item label="有效星期几">
                            <el-input v-model="dtj_week_txt" class="el-ellipsis" clearable placeholder="请选择有效星期几" @focus="dtjWeekSelect" @clear="dtjWeekDel"></el-input>
                        </el-form-item>
                        <el-form-item label="推荐设置">
                            <div v-for="(item, index) in dtj_edit_form.goods" :key="item.id" class="dtj-edit-goods">
                                <el-row>
                                    <label class="el-form-item__label">图片</label>
                                    <p>尺寸：960*300，大小不超过5M</p>
                                    <i class="el-icon-circle-plus" @click="dtjImgAdd" v-show="index==0"></i>
                                    <i class="el-icon-remove" @click="dtjImgDel(index)" v-show="index!=0"></i>
                                    <img :src="item.img" :id="item.img_id">
                                </el-row>
                                <el-row>
									<label class="el-form-item__label">关联商品</label>
                                    <el-input v-model="item.goods_name" class="el-ellipsis" clearable placeholder="请选择关联商品/商品套餐" @focus="dtjGoodsSelect(index)" @clear="dtjGoodsDel(index)"></el-input>
                                </el-row>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="dtjBackList">返回</el-button>
                            <el-button type="primary" @click="dtjEdit">确定</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 包厢号 -->
                <div class="multi-page" v-show="showDtjRoom">
                    <div class="page-tit">选择包厢</div>
                    <p>请选择包厢范围</p>
                    <div class="multi-page-main">
                        <div class="multi-page-row">
                            <div>
                                <input type="checkbox" v-model='dtj_room_all' @click='dtjRoomAll'>
                                <span>全部</span>
                            </div>
                            <ul></ul>
                        </div>
                        <div class="multi-page-row" v-for="(items, index) in dtj_room_arr" :key="items.room_area">
                            <div>
                                <input type="checkbox" v-model='dtj_room_floor' :value="items.room_area" @click="dtjRoomFloor(items.room_area, index)">
                                <span>{{items.room_area_name}}</span>
                            </div>
                            <ul class="clearfix">
                                <li v-for="item in items.room" :key="item.id">
                                    <input type="checkbox" v-model='dtj_room_item' :value="item.id">
                                    <span>{{item.name}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row">
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="dtjRoomBack()">返回</button>
                        <button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="dtjRoomSave()">确定</button>
                    </div>
                </div>
                <!-- 使用时间 -->
                <div class="use-time-wrap" ref="dtj_usetime_alert">
                    <h2>开始时间：</h2>
                    <el-row>
                        <el-col :span="11">
                            <el-select v-model="dtj_hour_start" filterable>
                                <el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                        <el-col class="el-line" :span="2">:</el-col>
                        <el-col :span="11">
                            <el-select v-model="dtj_minute_start" filterable>
                                <el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <h2>结束时间：</h2>
                    <el-row>
                        <el-col :span="11">
                            <el-select v-model="dtj_hour_end" filterable>
                                <el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                        <el-col class="el-line" :span="2">:</el-col>
                        <el-col :span="11">
                            <el-select v-model="dtj_minute_end" filterable>
                                <el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </div>
                <!-- 星期 -->
                <div class="export-wrap" ref="dtj_week_alert">
                    <el-checkbox :indeterminate="dtj_week_sign" v-model="dtj_week_all" @change="dtjWeekAll">全选</el-checkbox>
                    <el-checkbox-group v-model="dtj_week_ids" @change="dtjWeekChange">
                        <el-checkbox label="1">星期一</el-checkbox>
                        <el-checkbox label="2">星期二</el-checkbox>
                        <el-checkbox label="3">星期三</el-checkbox>
                        <el-checkbox label="4">星期四</el-checkbox>
                        <el-checkbox label="5">星期五</el-checkbox>
                        <el-checkbox label="6">星期六</el-checkbox>
                        <el-checkbox label="0">星期日</el-checkbox>
                    </el-checkbox-group>
                </div>
                <!-- 商品（套餐）弹窗 -->
                <div class="select-goods-wrap" ref="pop_goods_wrap">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-select v-model="pop_goods_type_name" clearable filterable placeholder="请选择类型" @change="popGoodsType">
                                <el-option v-for="item in goods_type_list" :key="item.id" :label="item.name" :value="item"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="10">
                            <el-input placeholder="请输入商品名称" v-model="pop_goods_name"></el-input>
                        </el-col>
                        <el-col :span="6">
                            <el-button class="pull-right" type="primary" @click="popGoodsTable(1)">查询</el-button>
                        </el-col>
                    </el-row>
                    <el-table
                        v-loading="loading"
                        element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)"
                        :data="pop_goods_table">
                        <el-table-column>
                            <template slot-scope="scope">
                                <el-radio v-model="pop_table_radio" :label="scope.$index" @change="popTableRow(scope.row)">&nbsp;</el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column prop="goods_type_name" label="类型"></el-table-column>
                        <el-table-column
                            v-for="(item, index) in pop_goods_columns"
                            :key="index"
                            :prop="item.prop"
                            :label="item.label">
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        background
                        layout="total, prev, pager, next, jumper"
                        :page-size="GLOBAL.PAGESIZEMINI"
                        :current-page.sync="pop_goods_page"
                        :total="pop_goods_total"
                        @current-change="popGoodsTable">
                    </el-pagination>
                </div>
            </div>



            <div v-show="listShow2">
                <div class="drc-list" v-show="showDrcList">
                    <el-row>
                        <el-button @click="backFun">返回</el-button>
                    </el-row>
                    <h1 class="pos-title">超市点单热搜词设置</h1>
                    <el-form :inline="true" :model="drc_list_form">
                        <el-form-item label="门店">
                            <el-select v-model="drc_list_form.shop_id" filterable placeholder="请选择门店">
                                <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="pull-right">
                            <el-button type="primary" @click="drcTable(1)">查询</el-button>
                            <el-button type="primary" @click="drcAdd">新增热搜词</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table
                        v-loading="loading"
                        element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)"
                        :data="drc_table">
                        <el-table-column prop="shop_name" label="适用门店"></el-table-column>
                        <el-table-column prop="listorder" label="优先级"></el-table-column>
                        <el-table-column prop="room_names" label="适用包厢"></el-table-column>
                        <el-table-column label="适用日期">
                            <template slot-scope="scope">
                                {{scope.row.use_every_day == '1' ? '每天' : scope.row.start_date + '~' + scope.row.end_date}}
                            </template>
                        </el-table-column>
                        <el-table-column label="适用时间段">
                            <template slot-scope="scope">
                                {{scope.row.start_time + '~' + scope.row.end_time}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="week_cycle_str" label="有效星期几"></el-table-column>
                        <el-table-column label="搜索词">
							<template slot-scope="scope">
                                {{scope.row.keywords.join()}}
                            </template>
						</el-table-column>
                        <el-table-column label="状态">
                            <template slot-scope="scope">
                                {{scope.row.status == '1' ? '启用' : '禁用'}}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="drcModify(scope.row)">修改</span>
                                <span class="text-blue" @click="drcDel(scope.row.id)">删除</span>
                                <span class="text-blue" @click="drcStatus(scope.row)">{{scope.row.status == '1' ? '禁用' : '启用'}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        background
                        layout="total, prev, pager, next, jumper"
                        :page-size="GLOBAL.PAGESIZE"
                        :current-page.sync="drc_page"
                        :total="drc_total"
                        @current-change="drcTable">
                    </el-pagination>
                </div>
				<div class="drc-edit" v-show="showDrcEdit">
                    <h2>{{drc_edit_tit}}</h2>
                    <el-form :model="drc_edit_form" label-width="120px">
                        <el-form-item label="门店">
                            <el-select v-model="drc_edit_form.shop_id" filterable placeholder="请选择门店" @change="drcShopChange">
                                <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="优先级">
                            <el-input placeholder="请输入规则优先级，数值大的优先" v-model="drc_edit_form.listorder"></el-input>
                        </el-form-item>
                        <el-form-item label="适用包厢">
                            <el-input v-model="drc_room_txt" class="el-ellipsis" clearable placeholder="请选择包厢号" @focus="drcRoomSelect" @clear="drcRoomDel"></el-input>
                        </el-form-item>
                        <el-form-item label="适用日期" class="drc-usedate-wrap">
                            <div ref="drc_usedate_main" class="drc-usedate-main">
                                <el-input v-model="drc_usedate_txt" class="el-ellipsis" placeholder="请选择适用日期"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item label="适用时间段">
                            <el-input v-model="drc_usetime_txt" class="el-ellipsis" placeholder="请选择适用时间" @click.native="drcUsetime"></el-input>
                        </el-form-item>
                        <el-form-item label="有效星期几">
                            <el-input v-model="drc_week_txt" class="el-ellipsis" clearable placeholder="请选择有效星期几" @focus="drcWeekSelect" @clear="drcWeekDel"></el-input>
                        </el-form-item>
                        <el-form-item label="搜索词设置">
                            <el-row v-for="(item, index) in drc_edit_form.keywords" :key="index" class="drc-edit-goods">
								<el-input placeholder="请输入搜索词名称" v-model="drc_edit_form.keywords[index]"></el-input>
								<i class="el-icon-circle-plus" @click="drcImgAdd" v-show="index==0"></i>
                                <i class="el-icon-remove" @click="drcImgDel(index)" v-show="index!=0"></i>
							</el-row>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="drcBackList">返回</el-button>
                            <el-button type="primary" @click="drcEdit">确定</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 包厢号 -->
                <div class="multi-page" v-show="showDrcRoom">
                    <div class="page-tit">选择包厢</div>
                    <p>请选择包厢范围</p>
                    <div class="multi-page-main">
                        <div class="multi-page-row">
                            <div>
                                <input type="checkbox" v-model='drc_room_all' @click='drcRoomAll'>
                                <span>全部</span>
                            </div>
                            <ul></ul>
                        </div>
                        <div class="multi-page-row" v-for="(items, index) in drc_room_arr" :key="items.room_area">
                            <div>
                                <input type="checkbox" v-model='drc_room_floor' :value="items.room_area" @click="drcRoomFloor(items.room_area, index)">
                                <span>{{items.room_area_name}}</span>
                            </div>
                            <ul class="clearfix">
                                <li v-for="item in items.room" :key="item.id">
                                    <input type="checkbox" v-model='drc_room_item' :value="item.id">
                                    <span>{{item.name}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row">
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="drcRoomBack()">返回</button>
                        <button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="drcRoomSave()">确定</button>
                    </div>
                </div>
                <!-- 使用时间 -->
                <div class="use-time-wrap" ref="drc_usetime_alert">
                    <h2>开始时间：</h2>
                    <el-row>
                        <el-col :span="11">
                            <el-select v-model="drc_hour_start" filterable>
                                <el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                        <el-col class="el-line" :span="2">:</el-col>
                        <el-col :span="11">
                            <el-select v-model="drc_minute_start" filterable>
                                <el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <h2>结束时间：</h2>
                    <el-row>
                        <el-col :span="11">
                            <el-select v-model="drc_hour_end" filterable>
                                <el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                        <el-col class="el-line" :span="2">:</el-col>
                        <el-col :span="11">
                            <el-select v-model="drc_minute_end" filterable>
                                <el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </div>
                <!-- 星期 -->
                <div class="export-wrap" ref="drc_week_alert">
                    <el-checkbox :indeterminate="drc_week_sign" v-model="drc_week_all" @change="drcWeekAll">全选</el-checkbox>
                    <el-checkbox-group v-model="drc_week_ids" @change="drcWeekChange">
                        <el-checkbox label="1">星期一</el-checkbox>
                        <el-checkbox label="2">星期二</el-checkbox>
                        <el-checkbox label="3">星期三</el-checkbox>
                        <el-checkbox label="4">星期四</el-checkbox>
                        <el-checkbox label="5">星期五</el-checkbox>
                        <el-checkbox label="6">星期六</el-checkbox>
                        <el-checkbox label="0">星期日</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>



            <div v-show="listShow3">
                <div class="pbs-list" v-show="showPbsList">
                    <el-row>
                        <el-button @click="backFun">返回</el-button>
                    </el-row>
                    <h1 class="pos-title">屏保设置</h1>
                    <el-form :inline="true" :model="pbs_list_form">
                        <el-form-item label="门店">
                            <el-select v-model="pbs_list_form.shop_id" filterable placeholder="请选择门店">
                                <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="pull-right">
                            <el-button type="primary" @click="pbsTable(1)">查询</el-button>
                            <el-button type="primary" @click="pbsAdd">新增屏保</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table
                        v-loading="loading"
                        element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)"
                        :data="pbs_table">
                        <el-table-column prop="shop_name" label="适用门店"></el-table-column>
                        <el-table-column prop="room_names" label="适用包厢"></el-table-column>
                        <el-table-column label="适用日期">
                            <template slot-scope="scope">
                                {{scope.row.use_every_day == '1' ? '每天' : scope.row.start_date + '~' + scope.row.end_date}}
                            </template>
                        </el-table-column>
                        <el-table-column label="适用时间段">
                            <template slot-scope="scope">
                                {{scope.row.start_time + '~' + scope.row.end_time}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="week_cycle_str" label="有效星期几"></el-table-column>
                        <el-table-column prop="img_num" label="图片"></el-table-column>
                        <el-table-column label="状态">
                            <template slot-scope="scope">
                                {{scope.row.status == '1' ? '启用' : '禁用'}}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="pbsModify(scope.row)">修改</span>
                                <span class="text-blue" @click="pbsDel(scope.row.id)">删除</span>
                                <span class="text-blue" @click="pbsStatus(scope.row)">{{scope.row.status == '1' ? '禁用' : '启用'}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        background
                        layout="total, prev, pager, next, jumper"
                        :page-size="GLOBAL.PAGESIZE"
                        :current-page.sync="pbs_page"
                        :total="pbs_total"
                        @current-change="pbsTable">
                    </el-pagination>
                </div>
				<div class="pbs-edit" v-show="showPbsEdit">
                    <h2>{{pbs_edit_tit}}</h2>
                    <el-form :model="pbs_edit_form" label-width="120px">
                        <el-form-item label="门店">
                            <el-select v-model="pbs_edit_form.shop_id" filterable placeholder="请选择门店" @change="pbsShopChange">
                                <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="适用包厢">
                            <el-input v-model="pbs_room_txt" class="el-ellipsis" clearable placeholder="请选择包厢号" @focus="pbsRoomSelect" @clear="pbsRoomDel"></el-input>
                        </el-form-item>
                        <el-form-item label="适用日期" class="pbs-usedate-wrap">
                            <div ref="pbs_usedate_main" class="pbs-usedate-main">
                                <el-input v-model="pbs_usedate_txt" class="el-ellipsis" placeholder="请选择适用日期"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item label="适用时间段">
                            <el-input v-model="pbs_usetime_txt" class="el-ellipsis" placeholder="请选择适用时间" @click.native="pbsUsetime"></el-input>
                        </el-form-item>
                        <el-form-item label="有效星期几">
                            <el-input v-model="pbs_week_txt" class="el-ellipsis" clearable placeholder="请选择有效星期几" @focus="pbsWeekSelect" @clear="pbsWeekDel"></el-input>
                        </el-form-item>
                        <el-form-item label="轮播时长间隔">
                            <el-input placeholder="请输入轮播图片间隔时长" v-model="pbs_edit_form.interval_time">
                                <template slot="append">S</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="轮播图片" class="pbs-imgs">
                            <h3><span>{{pbs_edit_form.imgs_num}}</span>/10张</h3>
                            <ul class="clearfix">
                                <li v-for="(item, index) in pbs_edit_form.img" :key="item.id">
                                    <img src="../../assets/images/scrn_del.png" class="pbs-imgs-del" @click="pbsImgsDel(index)">
                                    <img :src="item.src" :id="item.id" class="pbs-imgs-item">
                                </li>
                                <li><img src="../../assets/images/adsc_up.png" class="pbs-imgs-add" @click="pbsImgsAdd"></li>
                            </ul>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="pbsBackList">返回</el-button>
                            <el-button type="primary" @click="pbsEdit">确定</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 包厢号 -->
                <div class="multi-page" v-show="showPbsRoom">
                    <div class="page-tit">选择包厢</div>
                    <p>请选择包厢范围</p>
                    <div class="multi-page-main">
                        <div class="multi-page-row">
                            <div>
                                <input type="checkbox" v-model='pbs_room_all' @click='pbsRoomAll'>
                                <span>全部</span>
                            </div>
                            <ul></ul>
                        </div>
                        <div class="multi-page-row" v-for="(items, index) in pbs_room_arr" :key="items.room_area">
                            <div>
                                <input type="checkbox" v-model='pbs_room_floor' :value="items.room_area" @click="pbsRoomFloor(items.room_area, index)">
                                <span>{{items.room_area_name}}</span>
                            </div>
                            <ul class="clearfix">
                                <li v-for="item in items.room" :key="item.id">
                                    <input type="checkbox" v-model='pbs_room_item' :value="item.id">
                                    <span>{{item.name}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row">
                        <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="pbsRoomBack()">返回</button>
                        <button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="pbsRoomSave()">确定</button>
                    </div>
                </div>
                <!-- 使用时间 -->
                <div class="use-time-wrap" ref="pbs_usetime_alert">
                    <h2>开始时间：</h2>
                    <el-row>
                        <el-col :span="11">
                            <el-select v-model="pbs_hour_start" filterable>
                                <el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                        <el-col class="el-line" :span="2">:</el-col>
                        <el-col :span="11">
                            <el-select v-model="pbs_minute_start" filterable>
                                <el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <h2>结束时间：</h2>
                    <el-row>
                        <el-col :span="11">
                            <el-select v-model="pbs_hour_end" filterable>
                                <el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                        <el-col class="el-line" :span="2">:</el-col>
                        <el-col :span="11">
                            <el-select v-model="pbs_minute_end" filterable>
                                <el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </div>
                <!-- 星期 -->
                <div class="export-wrap" ref="pbs_week_alert">
                    <el-checkbox :indeterminate="pbs_week_sign" v-model="pbs_week_all" @change="pbsWeekAll">全选</el-checkbox>
                    <el-checkbox-group v-model="pbs_week_ids" @change="pbsWeekChange">
                        <el-checkbox label="1">星期一</el-checkbox>
                        <el-checkbox label="2">星期二</el-checkbox>
                        <el-checkbox label="3">星期三</el-checkbox>
                        <el-checkbox label="4">星期四</el-checkbox>
                        <el-checkbox label="5">星期五</el-checkbox>
                        <el-checkbox label="6">星期六</el-checkbox>
                        <el-checkbox label="0">星期日</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>

            <div v-show="listShow4">
                <div class="nav-list" v-show="!showNavSetPanel">
                    <el-row>
                        <el-button @click="backFun">返回</el-button>
                    </el-row>
                    <h1 class="pos-title">首页导航功能设置</h1>
                    <el-table
                        v-loading="loading"
                        element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)"
                        :data="nav_list">
                        <el-table-column prop="name" label="门店"></el-table-column>
                        <el-table-column label="巨好玩">
                            <template slot-scope="scope">
                                {{scope.row.fun_status == '1' ? '开启':'关闭'}}
                            </template>
                        </el-table-column>
                        <el-table-column label="超市">
                            <template slot-scope="scope">
                                {{scope.row.supermarket_status == '1' ? '开启':'关闭'}}
                            </template>
                        </el-table-column>
                        <el-table-column label="预约">
                            <template slot-scope="scope">
                                {{scope.row.personnel_book_status == '1' ? '开启':'关闭'}}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="onNavEditClick(scope.row)">修改</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        background
                        layout="total, prev, pager, next, jumper"
                        :page-size="GLOBAL.PAGESIZE"
                        :current-page.sync="nav_page"
                        :total="nav_total"
                        @current-change="getNavSetList">
                    </el-pagination>
                </div>
                <div class="nav-set" v-show="showNavSetPanel">
                    <h1>修改</h1>
                    <el-form label-width="80px">
                        <el-form-item label="巨好玩">
                            <el-radio v-model="nav_set_form.fun.status" label="1">开启</el-radio>
                            <el-radio v-model="nav_set_form.fun.status" label="-1">关闭</el-radio>
                        </el-form-item>
                        <el-form-item label="">
                            <div class="img-wrapper">
                                <img :src="nav_set_form.fun.img_url" alt="">
                                <div class="tip">按键图片比例342*113</div>
                                <el-button type="primary" size="small" id="fun-img">更换图片</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="超市">
                            <el-radio v-model="nav_set_form.supermarket.status" label="1">开启</el-radio>
                            <el-radio v-model="nav_set_form.supermarket.status" label="-1">关闭</el-radio>
                        </el-form-item>
                        <el-form-item label="">
                            <div class="img-wrapper">
                                <img :src="nav_set_form.supermarket.img_url" alt="">
                                <div class="tip">按键图片比例342*113</div>
                                <el-button type="primary" size="small" id="supermarket-img">更换图片</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="预约">
                            <el-radio v-model="nav_set_form.personnel_book.status" label="1">开启</el-radio>
                            <el-radio v-model="nav_set_form.personnel_book.status" label="-1">关闭</el-radio>
                        </el-form-item>
                        <el-form-item label="">
                            <div class="img-wrapper">
                                <img :src="nav_set_form.personnel_book.img_url" alt="">
                                <div class="tip">按键图片比例342*113</div>
                                <el-button type="primary" size="small" id="personnel-book-img">更换图片</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="showNavSetPanel=false">返回</el-button>
                            <el-button type="primary" @click="submitNavSet">保存</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                titShow: true,
                listShow1: false,
                listShow2: false,
                listShow3: false,
                listShow4: false,
                loading: false,
				shop_list: [],
				week_list: [{id: "1", name: "一"}, {id: "2", name: "二"}, {id: "3", name: "三"}, {id: "4", name: "四"}, {id: "5", name: "五"}, {id: "6", name: "六"}, {id: "0", name: "日"}],

                showDtjList: true,
                showDtjEdit: false,
                showDtjRoom: false,
                dtj_list_form: {
                    shop_id: ''
                },
                dtj_page: 1,
				dtj_total: 0,
                dtj_table: [],
                dtj_edit_id: '',
				dtj_edit_tit: '',
				dtj_edit_form: {
					shop_id: '',
					listorder: '',
                    goods: [{
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'dtjImg0',
                        img_done: false,
                        type: '',
                        goods_id: '',
                        goods_name: ''
                    }]
				},
				dtj_room_txt: '',
				dtj_use_all_room: -1,
				dtj_room_all: false,
                dtj_room_item: [],
				dtj_c_room_item: [],
				dtj_room_floor: [],
				dtj_room_arr: [],
				dtj_room_arr_det: [],
				dtj_usedate_txt: '',
				dtj_use_every_day: -1,
				dtj_usedate_start: '',
                dtj_usedate_end: '',
                dtj_usetime_txt: '',
                dtj_usetime_start: '',
                dtj_usetime_end: '',
                dtj_hour_start: '00',
                dtj_minute_start: '00',
                dtj_hour_end: '00',
                dtj_minute_end: '00',
                dtj_week_txt: '',
				dtj_week_sign: false,
				dtj_week_all: false,
				dtj_week_ids: [],
                // 商品（套餐）弹窗
                pop_goods_shop_id: '',
				pop_goods_type_id: '',
				pop_goods_type_name: '',
				pop_goods_type_sign: '',
				goods_type_list: [{
					id: "-2",
					name: "商品套餐",
					type: 'package',
					type_id: ''
				}],
				pop_goods_name: '',
                pop_table_radio: '',
                pop_table_select: {},
				pop_goods_page: 1,
				pop_goods_total: 0,
                pop_goods_table: [],
				pop_goods_columns: [],

				showDrcList: true,
                showDrcEdit: false,
                showDrcRoom: false,
                drc_list_form: {
                    shop_id: ''
                },
                drc_page: 1,
				drc_total: 0,
                drc_table: [],
                drc_edit_id: '',
				drc_edit_tit: '',
				drc_edit_form: {
					shop_id: '',
					listorder: '',
                    keywords: ['']
				},
				drc_room_txt: '',
				drc_use_all_room: -1,
				drc_room_all: false,
                drc_room_item: [],
				drc_c_room_item: [],
				drc_room_floor: [],
				drc_room_arr: [],
				drc_room_arr_det: [],
				drc_usedate_txt: '',
				drc_use_every_day: -1,
				drc_usedate_start: '',
                drc_usedate_end: '',
                drc_usetime_txt: '',
                drc_usetime_start: '',
                drc_usetime_end: '',
                drc_hour_start: '00',
                drc_minute_start: '00',
                drc_hour_end: '00',
                drc_minute_end: '00',
                drc_week_txt: '',
				drc_week_sign: false,
				drc_week_all: false,
				drc_week_ids: [],

				showPbsList: true,
                showPbsEdit: false,
                showPbsRoom: false,
                pbs_list_form: {
                    shop_id: ''
                },
                pbs_page: 1,
				pbs_total: 0,
                pbs_table: [],
                pbs_edit_id: '',
				pbs_edit_tit: '',
				pbs_edit_form: {
					shop_id: '',
					interval_time: '',
                    imgs_num: '0',
                    img: []
				},
				pbs_room_txt: '',
				pbs_use_all_room: -1,
				pbs_room_all: false,
                pbs_room_item: [],
				pbs_c_room_item: [],
				pbs_room_floor: [],
				pbs_room_arr: [],
				pbs_room_arr_det: [],
				pbs_usedate_txt: '',
				pbs_use_every_day: -1,
				pbs_usedate_start: '',
                pbs_usedate_end: '',
                pbs_usetime_txt: '',
                pbs_usetime_start: '',
                pbs_usetime_end: '',
                pbs_hour_start: '00',
                pbs_minute_start: '00',
                pbs_hour_end: '00',
                pbs_minute_end: '00',
                pbs_week_txt: '',
				pbs_week_sign: false,
				pbs_week_all: false,
				pbs_week_ids: [],

                nav_list: [],
                nav_page: 1,
                nav_total: 0,
                showNavSetPanel: false,
                nav_set_form: {
                    supermarket: {
                        id: '',
                        img_url: '',
                        status: '',
                        key: "supermarket"
                    },
                    fun: {
                        id: "32",
                        img_url: '',
                        status: '',
                        key: "fun"
                    },
                    personnel_book: {
                        id: '',
                        img_url: '',
                        status: '',
                        key: "personnel_book"
                    }
                },
                nav_set_uploaders: [],
            }
        },
        computed: {
            menu() {
                let menu = {};
                if(!$.isEmptyObject(this.$store.state.menunew)) {
                    menu = JSON.parse(this.$store.state.menunew);
                    $.each(menu, function(k, v) {
                        if(v.id == '546') {
                            menu = v.submenu;
                            $.each(menu, function(m, n) {
                                if(n.id == '957') {
                                    menu = n.submenu;
                                }
                            });
                        }
                    });
                }
                return menu;
            },
        },
        watch: {
            dtj_room_item: {
				handler: function(val, oldVal) {
					const _this = this;

					if(_this.dtj_room_item.length >= _this.dtj_room_arr_det.length) {
						_this.dtj_room_all = true;
					} else {
						_this.dtj_room_all = false;
					}

					$.each(_this.dtj_room_arr, function(k, v) {
						if(_this.dtj_room_item.length >= v.room.length) {
							let num = 0;
							for(let i = 0, len = v.room.length; i < len; i++) {
								if(_this.dtj_room_item.indexOf(v.room[i].id) != -1) {
									num++;
								}
								if(i == v.room.length - 1 && num == v.room.length) {
									if(_this.dtj_room_floor.indexOf(v.room_area) == -1) {
										_this.dtj_room_floor.push(v.room_area);
									}
								} else {
									let index = '';
									index = _this.dtj_room_floor.indexOf(v.room_area);
									if(index != -1) {
										_this.dtj_room_floor.splice(index, 1);
									}
								}
							}
						} else {
							let index = '';
							index = _this.dtj_room_floor.indexOf(v.room_area);
							if(index != -1) {
								_this.dtj_room_floor.splice(index, 1);
							}
						}
					});
				},
				deep: true
			},

			drc_room_item: {
				handler: function(val, oldVal) {
					const _this = this;

					if(_this.drc_room_item.length >= _this.drc_room_arr_det.length) {
						_this.drc_room_all = true;
					} else {
						_this.drc_room_all = false;
					}

					$.each(_this.drc_room_arr, function(k, v) {
						if(_this.drc_room_item.length >= v.room.length) {
							let num = 0;
							for(let i = 0, len = v.room.length; i < len; i++) {
								if(_this.drc_room_item.indexOf(v.room[i].id) != -1) {
									num++;
								}
								if(i == v.room.length - 1 && num == v.room.length) {
									if(_this.drc_room_floor.indexOf(v.room_area) == -1) {
										_this.drc_room_floor.push(v.room_area);
									}
								} else {
									let index = '';
									index = _this.drc_room_floor.indexOf(v.room_area);
									if(index != -1) {
										_this.drc_room_floor.splice(index, 1);
									}
								}
							}
						} else {
							let index = '';
							index = _this.drc_room_floor.indexOf(v.room_area);
							if(index != -1) {
								_this.drc_room_floor.splice(index, 1);
							}
						}
					});
				},
				deep: true
			},

            pbs_room_item: {
				handler: function(val, oldVal) {
					const _this = this;

					if(_this.pbs_room_item.length >= _this.pbs_room_arr_det.length) {
						_this.pbs_room_all = true;
					} else {
						_this.pbs_room_all = false;
					}

					$.each(_this.pbs_room_arr, function(k, v) {
						if(_this.pbs_room_item.length >= v.room.length) {
							let num = 0;
							for(let i = 0, len = v.room.length; i < len; i++) {
								if(_this.pbs_room_item.indexOf(v.room[i].id) != -1) {
									num++;
								}
								if(i == v.room.length - 1 && num == v.room.length) {
									if(_this.pbs_room_floor.indexOf(v.room_area) == -1) {
										_this.pbs_room_floor.push(v.room_area);
									}
								} else {
									let index = '';
									index = _this.pbs_room_floor.indexOf(v.room_area);
									if(index != -1) {
										_this.pbs_room_floor.splice(index, 1);
									}
								}
							}
						} else {
							let index = '';
							index = _this.pbs_room_floor.indexOf(v.room_area);
							if(index != -1) {
								_this.pbs_room_floor.splice(index, 1);
							}
						}
					});
				},
				deep: true
			}
        },
        created: function() {
            this.getShop()
			this.getGoodsPackageType()
        },
        mounted: function() {
            this.dtjImgUploadInit()
        },
        methods: {
            titClk: function(num) {
                const _this = this
                _this.titShow = false
                _this.listShow1 = false
                _this.listShow2 = false
                _this.listShow3 = false
                _this.listShow4 = false

                if(num == '960') {
                    _this.dtj_list_form.shop_id = _this.shop_list[0].id
                    _this.dtjTable(1)
                    _this.initDate('dtj')
                    _this.listShow1 = true
                } else if(num == '959') {
                    _this.drc_list_form.shop_id = _this.shop_list[0].id
                    _this.drcTable(1)
                    _this.initDate('drc')
                    _this.listShow2 = true
                } else if(num == '958') {
                    _this.pbs_list_form.shop_id = _this.shop_list[0].id
                    _this.pbsTable(1)
                    _this.initDate('pbs')
                    _this.listShow3 = true
                } else if(num == '1163') {
                    _this.listShow4 = true
                    _this.getNavSetList(1)
                }
            },
            backFun: function() {
                this.titShow = true
                this.listShow1 = false
                this.listShow2 = false
                this.listShow3 = false
                this.listShow4 = false
            },
            getShop: function() {
                const _this = this

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result
                        _this.shop_list.shift()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this)
                        layer.msg(res.data.response.error_msg)
                    }
                })
                .catch(err => {
                    layer.msg('出错啦')
                })
            },
            // 日期
			initDate: function(name) {
                const _this = this;

                if(name === 'dtj') {
                    $(_this.$refs.dtj_usedate_main).daterangepicker({
                        parentEl: '.dtj-usedate-wrap',
                        // drops: 'up',
                        buttonClasses: ['btn btn-default'],
                        applyClass: 'btn-small btn-orange',
                        cancelClass: 'btn-small btn-gray',
                    }, function(start, end, label) {
					    event.preventDefault()
                        _this.dtj_usedate_start = start.format('YYYY-MM-DD');
                        _this.dtj_usedate_end = end.format('YYYY-MM-DD');
                        if($(".dtj-usedate-everyday input").val() == "1") {
                            _this.dtj_usedate_txt = '每天';
                            _this.dtj_use_every_day = 1;
                            return;
                        } else {
                            _this.dtj_usedate_txt = _this.dtj_usedate_start + ' ~ ' + _this.dtj_usedate_end;
                            _this.dtj_use_every_day = -1;
                        }
                    });
                    $(".dtj-usedate-wrap .daterangepicker:last").find(".ranges").prepend(
                        '<div class="dtj-usedate-everyday">' +
                            '<input type="checkbox" />' +
                            '<label>每天</label>' +
                        '</div>'
                    );
                    $(".dtj-usedate-everyday input").click(function() {
                        if($(this).val() == "1") {
                            $(this).prop("checked", false);
                            $(this).val('');
                        } else {
                            $(this).prop("checked", true);
                            $(this).val('1');
                        }
                    });
                } else if(name === 'drc') {
                    $(_this.$refs.drc_usedate_main).daterangepicker({
                        parentEl: '.drc-usedate-wrap',
                        // drops: 'up',
                        buttonClasses: ['btn btn-default'],
                        applyClass: 'btn-small btn-orange',
                        cancelClass: 'btn-small btn-gray',
                    }, function(start, end, label) {
					    event.preventDefault()
                        _this.drc_usedate_start = start.format('YYYY-MM-DD');
                        _this.drc_usedate_end = end.format('YYYY-MM-DD');
                        if($(".drc-usedate-everyday input").val() == "1") {
                            _this.drc_usedate_txt = '每天';
                            _this.drc_use_every_day = 1;
                            return;
                        } else {
                            _this.drc_usedate_txt = _this.drc_usedate_start + ' ~ ' + _this.drc_usedate_end;
                            _this.drc_use_every_day = -1;
                        }
                    });
                    $(".drc-usedate-wrap .daterangepicker:last").find(".ranges").prepend(
                        '<div class="drc-usedate-everyday">' +
                            '<input type="checkbox" />' +
                            '<label>每天</label>' +
                        '</div>'
                    );
                    $(".drc-usedate-everyday input").click(function() {
                        if($(this).val() == "1") {
                            $(this).prop("checked", false);
                            $(this).val('');
                        } else {
                            $(this).prop("checked", true);
                            $(this).val('1');
                        }
                    });
                } else if(name === 'pbs') {
                    $(_this.$refs.pbs_usedate_main).daterangepicker({
                        parentEl: '.pbs-usedate-wrap',
                        // drops: 'up',
                        buttonClasses: ['btn btn-default'],
                        applyClass: 'btn-small btn-orange',
                        cancelClass: 'btn-small btn-gray',
                    }, function(start, end, label) {
					    event.preventDefault()
                        _this.pbs_usedate_start = start.format('YYYY-MM-DD');
                        _this.pbs_usedate_end = end.format('YYYY-MM-DD');
                        if($(".pbs-usedate-everyday input").val() == "1") {
                            _this.pbs_usedate_txt = '每天';
                            _this.pbs_use_every_day = 1;
                            return;
                        } else {
                            _this.pbs_usedate_txt = _this.pbs_usedate_start + ' ~ ' + _this.pbs_usedate_end;
                            _this.pbs_use_every_day = -1;
                        }
                    });
                    $(".pbs-usedate-wrap .daterangepicker:last").find(".ranges").prepend(
                        '<div class="pbs-usedate-everyday">' +
                            '<input type="checkbox" />' +
                            '<label>每天</label>' +
                        '</div>'
                    );
                    $(".pbs-usedate-everyday input").click(function() {
                        if($(this).val() == "1") {
                            $(this).prop("checked", false);
                            $(this).val('');
                        } else {
                            $(this).prop("checked", true);
                            $(this).val('1');
                        }
                    });
                }
			},
            // 获取商品套餐类型
            getGoodsPackageType() {
				const _this = this;

				Vue.axios.post('PublicData/api_getWaresType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						res.data.response.result.data.forEach(v => {
							_this.goods_type_list.push({
								id: '-2' + v.id,
								name: v.name,
								type: 'package',
								type_id: v.id
							});
						});
						_this.getGoodsType();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
            // 获取商品类型
			getGoodsType: function() {
				const _this = this;

				Vue.axios.post('PublicData/api_getGoodsType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						res.data.response.result.data.forEach(v => {
							_this.goods_type_list.push({
								id: v.id,
								name: v.name
							});
						});
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
            // 更改商品（套餐）类型
			popGoodsType(val) {
				this.pop_goods_type_sign = val.type
				if(this.pop_goods_type_sign == 'package') {
					this.pop_goods_type_id = val.type_id
					this.pop_goods_type_name = val.name
				} else {
					this.pop_goods_type_id = val.id
					this.pop_goods_type_name = val.name
				}
				this.popGoodsTable(1)
			},
            // 获取商品（套餐）
			popGoodsTable: function(page) {
				const _this = this

				_this.loading = true
				_this.pop_goods_page = page
				let url = "merchantGoods/searchMerchantGoodsList"
				let data = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZEMINI,
							"shop_id": _this.dtj_edit_form.shop_id,
							"goods_type": _this.pop_goods_type_id,
							"goods_name": _this.pop_goods_name,
							"status": '1'
						}
					},
					"comment": ""
				};
				if(_this.pop_goods_type_sign == 'package') {
					url = "merchantGoods/searchMerchantGoodsPackage";
				}
				Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.pop_goods_total = Number(res.data.response.result.data.total);
						}
						if(_this.pop_goods_type_sign == 'package') {
							_this.pop_goods_columns = [{
								"prop": 'name',
								"label": '名称'
							}, {
								"prop": 'package_unit_name',
								"label": '单位'
							}]
						} else {
							_this.pop_goods_columns = [{
								"prop": 'goods_name',
								"label": '名称'
							}, {
								"prop": 'goods_unit_name',
								"label": '单位'
							}]
						}
						_this.pop_goods_table = res.data.response.result.data.rows
						_this.loading = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
            // 单选
            popTableRow(row) {
                this.pop_table_select = row
            },
            // 添加商品（套餐）
			dtjGoodsSelect(index) {
				const _this = this;

				_this.csg_type = ''
				_this.pop_goods_name = ''
				_this.pop_goods_page = 1
                _this.pop_table_radio = ''
				_this.popGoodsTable(1)
				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择关联商品', true],
                    area: ['700px', '500px'], // 宽高
                    content: $(_this.$refs.pop_goods_wrap)
                }, function() {
                    // 保存
					if(_this.pop_goods_type_sign == 'package') {
						_this.dtj_edit_form.goods[index].type = 2
						_this.dtj_edit_form.goods[index].goods_id = _this.pop_table_select.id
						_this.dtj_edit_form.goods[index].goods_name = _this.pop_table_select.name
					} else {
						_this.dtj_edit_form.goods[index].type = 1
						_this.dtj_edit_form.goods[index].goods_id = _this.pop_table_select.id
						_this.dtj_edit_form.goods[index].goods_name = _this.pop_table_select.goods_name
					}
                    layer.closeAll()
                });
			},
            // 删除
			dtjGoodsDel(index) {
				this.dtj_edit_form.goods[index].type = ''
				this.dtj_edit_form.goods[index].goods_id = ''
				this.dtj_edit_form.goods[index].goods_name = ''
            },



            /*
             * 超市点单推荐设置
             */
            // 列表
			dtjTable: function(page) {
				const _this = this;

				_this.loading = true;
                _this.dtj_page = page
				Vue.axios.post('Ipad/getRecommendGoodsList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.dtj_list_form.shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.dtj_total = Number(res.data.response.result.total);
						}
						_this.dtj_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 禁用启用
            dtjStatus(row) {
                const _this = this;

				layer.confirm('确定'+ (row.status == '1' ? '禁用' : '启用') +'吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('Ipad/updateRecommendGoodsStatus', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": row.id,
                                "status": -row.status
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('操作成功');
							_this.dtjTable(_this.dtj_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 删除
			dtjDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('Ipad/delRecommendGoodsData', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.dtjTable(_this.dtj_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 点击新增
			dtjAdd() {
                const _this = this
                _this.dtj_edit_id = ''
                _this.dtj_edit_tit = '新增推荐'
                _this.dtj_edit_form = {
                    shop_id: _this.shop_list[0].id,
					listorder: '',
                    goods: [{
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'dtjImg0',
                        img_done: false,
                        type: '',
                        goods_id: '',
                        goods_name: ''
                    }]
                }
                new Promise(resolve => {
					_this.dtjRoomList(_this.dtj_edit_form.shop_id, resolve)
				})
				.then(res => {
					_this.dtj_use_all_room = -1
					_this.dtj_room_txt = ''
					_this.dtj_room_item = []
				})
				_this.dtj_usedate_txt = ''
				_this.dtj_use_every_day = -1
                $(".dtj-usedate-everyday input").val("");
                $(".dtj-usedate-everyday input").prop("checked", false);
				_this.dtj_usedate_start = ''
                _this.dtj_usedate_end = ''
				_this.dtj_usetime_txt = ''
				_this.dtj_usetime_start = ''
				_this.dtj_usetime_end = ''
                _this.dtj_week_txt = ''
                _this.dtj_week_ids = []
                _this.dtj_week_sign = false
                _this.dtj_week_all = false
                this.dtjImgUpload('dtjImg0', 0)
                _this.showDtjList = false
                _this.showDtjEdit = true
			},
			// 点击修改
			dtjModify(id) {
                const _this = this

                Vue.axios.post('Ipad/getRecommendGoodsData', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "id": id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						const row = res.data.response.result

                        _this.dtj_edit_id = row.id
                        _this.dtj_edit_tit = '修改推荐'
                        _this.dtj_edit_form = {
                            shop_id: row.shop_id,
                            listorder: row.listorder,
                            goods: []
                        }
                        new Promise(resolve => {
                            _this.dtjRoomList(_this.dtj_edit_form.shop_id, resolve)
                        }).then(res => {
                			_this.dtj_use_all_room = row.all_room
							_this.dtj_room_txt = row.room_names
							_this.dtj_room_item = row.room_ids.split(',')
						})
                        _this.dtj_use_every_day = row.use_every_day
                        _this.dtj_usedate_start = row.start_date
                        _this.dtj_usedate_end = row.end_date
                        if(row.use_every_day == 1) {
                            $(".dtj-usedate-everyday input").val("1");
                            $(".dtj-usedate-everyday input").prop("checked", true);
                            _this.dtj_usedate_txt = '每天'
                        } else {
                            $(".dtj-usedate-everyday input").val("");
                            $(".dtj-usedate-everyday input").prop("checked", false);
                            _this.dtj_usedate_txt = row.start_date + '~' + row.end_date
                        }
                        _this.dtj_usetime_txt = row.start_time + '~' + row.end_time
                        _this.dtj_usetime_start = row.start_time
                        _this.dtj_usetime_end = row.end_time
                        _this.dtj_week_ids = row.week_cycle
                        _this.dtj_week_sign = _this.dtj_week_ids.length > 0 && _this.dtj_week_ids.length < _this.week_list.length;
                        _this.dtj_week_all = _this.dtj_week_ids.length === _this.week_list.length;
                        let week_txt = [];
                        _this.week_list.forEach(_ => {
                            _this.dtj_week_ids.forEach(item => {
                                if(_.id == item) {
                                    week_txt.push(_.name);
                                }
                            });
                        });
                        _this.dtj_week_txt = week_txt.join(',');
                        if(row.goods.length == 0) {
                            this.dtj_edit_form.goods = [{
                                img: require('../../assets/images/upload_btn.png'),
                                img_id: 'dtjImg0',
                                img_done: false,
                                type: '',
                                goods_id: '',
                                goods_name: ''
                            }]
                        } else {
                            row.goods.forEach((item, index) => {
                                this.dtj_edit_form.goods.push({
                                    img: item.img,
                                    img_id: 'dtjImg' + index,
                                    img_done: true,
                                    type: item.type,
                                    goods_id: item.goods_id,
                                    goods_name: item.goods_name,
                                })
                                this.dtjImgUpload('dtjImg' + index, index)
                            })
                        }
                        _this.showDtjList = false
                        _this.showDtjEdit = true
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            dtjShopChange(val) {
				new Promise(resolve => {
					this.dtjRoomList(val, resolve)
				})
				this.dtj_use_all_room = -1
				this.dtj_room_txt = ''
				this.dtj_room_item = []
			},
			// 获取包厢号
			dtjRoomList: function(shop_id, resolve) {
				const _this = this;

				Vue.axios.post('Shop/getAllRoomByArea', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.dtj_room_arr = res.data.response.result;
						_this.dtj_room_arr_det = [];
						res.data.response.result.forEach(_ => {
							_.room.forEach(item => _this.dtj_room_arr_det.push(item))
						});
						resolve();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			// 点击选择包厢号
			dtjRoomSelect: function(e) {
                this.dtj_c_room_item = [...this.dtj_room_item]
				this.showDtjEdit = false
				this.showDtjRoom = true
			},
			dtjRoomDel() {
				this.dtj_use_all_room = -1
				this.dtj_room_txt = ''
				this.dtj_room_item = []
			},
			// 全选
			dtjRoomAll: function() {
				const _this = this;

				if(!_this.dtj_room_all) { // 实现全选
					_this.dtj_room_item = [];
					_this.dtj_room_arr_det.forEach(item => {
						_this.dtj_room_item.push(item.id);
					});
				} else { // 实现反选
					_this.dtj_room_item = [];
				}
			},
			// 楼层全选/反选
			dtjRoomFloor: function(id, index) {
				const _this = this;

				if(_this.dtj_room_floor.indexOf(id) == -1) {
					_this.dtj_room_arr[index].room.forEach(item => {
						if(_this.dtj_room_item.indexOf(item.id) == -1) {
							_this.dtj_room_item.push(item.id);
						}
					});
				} else {
					_this.dtj_room_arr[index].room.forEach(item => {
						let index = '';
						index = _this.dtj_room_item.indexOf(item.id);
						if(index != -1) {
							_this.dtj_room_item.splice(index, 1);
						}
					});
				}
			},
			// 确定包厢
			dtjRoomSave: function() {
				const _this = this;

				if(_this.dtj_room_all) {
					_this.dtj_room_txt = '全部'
					_this.dtj_use_all_room = 1
				} else {
					let texts = [];
					_this.dtj_room_arr_det.forEach(_ => {
						_this.dtj_room_item.forEach(item => {
							if(_.id == item) {
								texts.push(_.name);
							}
						});
					});
					_this.dtj_room_txt = texts.join(",");
					_this.dtj_use_all_room = -1;
				}
				_this.showDtjEdit = true
				_this.showDtjRoom = false
			},
			// 返回
			dtjRoomBack: function() {
				this.dtj_room_item = [...this.dtj_c_room_item]
				this.showDtjEdit = true
				this.showDtjRoom = false
			},
			dtjUsetime: function() {
                const _this = this;

				_this.dtj_hour_start = _this.dtj_usetime_start.split(':')[0] || '00'
				_this.dtj_minute_start = _this.dtj_usetime_start.split(':')[1] || '00'
				_this.dtj_hour_end = _this.dtj_usetime_end.split(':')[0] || '00'
				_this.dtj_minute_end = _this.dtj_usetime_end.split(':')[1] || '00'
				layer.confirm('', {
					type: 1,
					skin: 'public-alert-skin',
					btn: ['确定', '取消'], // 按钮
					title: '使用时间',
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.dtj_usetime_alert)
				}, function() {
					_this.dtj_usetime_start = _this.dtj_hour_start + ":" + _this.dtj_minute_start
					_this.dtj_usetime_end = _this.dtj_hour_end + ":" + _this.dtj_minute_end
					_this.dtj_usetime_txt = _this.dtj_usetime_start + " ~ " + _this.dtj_usetime_end
					layer.closeAll();
				});
			},
			// 星期
            dtjWeekSelect() {
                const _this = this;
                const c_week_ids = _this.dtj_week_ids,
                    c_week_sign = _this.dtj_week_sign,
                    c_week_all = _this.dtj_week_all;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择星期', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.dtj_week_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.dtj_week_ids = c_week_ids;
                        _this.dtj_week_sign = c_week_sign;
                        _this.dtj_week_all = c_week_all;
                    }
                }, function() {
                    let arr = [];
                    _this.week_list.forEach(item => {
                        _this.dtj_week_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.dtj_week_txt = arr.join(',');
                    layer.closeAll();
                }, function() {
                    _this.dtj_week_ids = c_week_ids;
                    _this.dtj_week_sign = c_week_sign;
                    _this.dtj_week_all = c_week_all;
                });
            },
            dtjWeekDel() {
				this.dtj_week_sign = false;
                this.dtj_week_all = false;
				this.dtj_week_ids = [];
            },
            dtjWeekAll(val) {
                let ids = [];
				this.week_list.forEach(v => {
					ids.push(v.id);
				});
				this.dtj_week_ids = val ? ids : [];
				this.dtj_week_sign = false;
			},
			dtjWeekChange(val) {
				const len = val.length;
				this.dtj_week_sign = len > 0 && len < this.week_list.length;
				this.dtj_week_all = len === this.week_list.length;
            },
            // 新增商品
            dtjImgAdd: function() {
                const index = this.dtj_edit_form.goods.length
                this.dtj_edit_form.goods.push({
                    img: require('../../assets/images/upload_btn.png'),
                    img_id: 'dtjImg' + index,
                    img_done: false,
                    type: '',
                    goods_id: '',
                    goods_name: ''
                })
				this.dtjImgUpload('dtjImg' + index, index)
            },
            // 删除商品
            dtjImgDel: function(num) {
                this.dtj_edit_form.goods.splice(num, 1)
                this.dtj_edit_form.goods.forEach((item, index) => {
                    this.dtj_edit_form.goods[index].img_id = 'dtjImg' + index
                })
            },
            // 上传人物图片
            dtjImgUploadInit: function() {
				let _this = this;
				let host = '',
					dir = '',
					file_name = '';

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: 'dtjImg0', // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "Image files", extensions: "jpg,jpeg,png,gif" }
							],
							max_file_size: '5mb', // 文件大小限制
							// prevent_duplicates: true // 不允许选取重复文件
						},
						resize: {
							width: 960,
							height: 300
						},
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 文件上传前触发
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
								// 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'system_set'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host;
										dir = res.data.response.data.dir;
										file_name = res.data.response.data.file_name;
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': res.data.response.data.accessid,
											'policy': res.data.response.data.policy,
											'signature': res.data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

										// 上传文件
										uploader.start();
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
							},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
								_this.dtj_edit_form.goods[0].img = host + "/" + dir + file_name;
								_this.dtj_edit_form.goods[0].img_done = true;
								layer.msg('上传成功');
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传jpg,jpeg,png,gif文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
								}
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },
            dtjImgUpload: function(id, index) {
                if(index === 0) {
                    return false;
                }
				let _this = this;
				let host = '',
					dir = '',
					file_name = '';

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: id, // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "Image files", extensions: "jpg,jpeg,png,gif" }
							],
							max_file_size: '5mb', // 文件大小限制
							// prevent_duplicates: true // 不允许选取重复文件
						},
						resize: {
							width: 960,
							height: 300
						},
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 文件上传前触发
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
								// 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'system_set'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host;
										dir = res.data.response.data.dir;
										file_name = res.data.response.data.file_name;
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': res.data.response.data.accessid,
											'policy': res.data.response.data.policy,
											'signature': res.data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

										// 上传文件
										uploader.start();
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
							},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
								_this.dtj_edit_form.goods[index].img = host + "/" + dir + file_name;
								_this.dtj_edit_form.goods[index].img_done = true;
								layer.msg('上传成功');
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传jpg,jpeg,png,gif文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
								}
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },
            // 新增、修改
			dtjEdit() {
				const _this = this;

				let url = 'Ipad/addRecommendGoodsData'
				let data = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": _this.dtj_edit_form.shop_id,
							"listorder": _this.dtj_edit_form.listorder,
							"all_room": _this.dtj_use_all_room,
							"room_ids": _this.dtj_room_item,
							"use_every_day": _this.dtj_use_every_day,
							"start_date": _this.dtj_usedate_start,
							"end_date": _this.dtj_usedate_end,
							"start_time": _this.dtj_usetime_start,
							"end_time": _this.dtj_usetime_end,
							"week_cycle": _this.dtj_week_ids,
							"goods": _this.dtj_edit_form.goods
						}
					},
					"comment": ""
				};
				if(_this.dtj_edit_id) {
					url = 'Ipad/editRecommendGoodsData'
					data.request.param.id = _this.dtj_edit_id;
				}
				Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功');
						_this.dtjTable(_this.dtj_page);
						_this.showDtjList = true;
						_this.showDtjEdit = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			dtjBackList() {
				this.showDtjList = true;
				this.showDtjEdit = false;
			},



            /*
             * 超市点单热搜词设置
             */
            // 列表
			drcTable: function(page) {
				const _this = this;

				_this.loading = true;
                _this.drc_page = page
				Vue.axios.post('Ipad/getSearchKeywordsList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.drc_list_form.shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.drc_total = Number(res.data.response.result.total);
						}
						_this.drc_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 禁用启用
            drcStatus(row) {
                const _this = this;

				layer.confirm('确定'+ (row.status == '1' ? '禁用' : '启用') +'吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('Ipad/updateSearchKeywordsStatus', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": row.id,
                                "status": -row.status
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('操作成功');
							_this.drcTable(_this.drc_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 删除
			drcDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('Ipad/delSearchKeywordsData', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.drcTable(_this.drc_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 点击新增
			drcAdd() {
                const _this = this
                _this.drc_edit_id = ''
                _this.drc_edit_tit = '新增热搜词'
                _this.drc_edit_form = {
                    shop_id: _this.shop_list[0].id,
					listorder: '',
                    keywords: ['']
                }
                new Promise(resolve => {
					_this.drcRoomList(_this.drc_edit_form.shop_id, resolve)
				})
				.then(res => {
					_this.drc_use_all_room = -1
					_this.drc_room_txt = ''
					_this.drc_room_item = []
				})
				_this.drc_usedate_txt = ''
				_this.drc_use_every_day = -1
                $(".drc-usedate-everyday input").val("");
                $(".drc-usedate-everyday input").prop("checked", false);
				_this.drc_usedate_start = ''
                _this.drc_usedate_end = ''
				_this.drc_usetime_txt = ''
				_this.drc_usetime_start = ''
				_this.drc_usetime_end = ''
                _this.drc_week_txt = ''
                _this.drc_week_ids = []
                _this.drc_week_sign = false
                _this.drc_week_all = false
                _this.showDrcList = false
                _this.showDrcEdit = true
			},
			// 点击修改
			drcModify(row) {
				const _this = this

                _this.drc_edit_id = row.id
				_this.drc_edit_tit = '修改热搜词'
				_this.drc_edit_form = {
					shop_id: row.shop_id,
					listorder: row.listorder,
					keywords: row.keywords || ['']
				}
				new Promise(resolve => {
					_this.drcRoomList(_this.drc_edit_form.shop_id, resolve)
				}).then(res => {
                	_this.drc_use_all_room = row.all_room
					_this.drc_room_txt = row.room_names
					_this.drc_room_item = row.room_ids.split(',')
				})
				_this.drc_use_every_day = row.use_every_day
				_this.drc_usedate_start = row.start_date
				_this.drc_usedate_end = row.end_date
				if(row.use_every_day == 1) {
					$(".drc-usedate-everyday input").val("1");
					$(".drc-usedate-everyday input").prop("checked", true);
					_this.drc_usedate_txt = '每天'
				} else {
					$(".drc-usedate-everyday input").val("");
					$(".drc-usedate-everyday input").prop("checked", false);
					_this.drc_usedate_txt = row.start_date + '~' + row.end_date
				}
				_this.drc_usetime_txt = row.start_time + '~' + row.end_time
				_this.drc_usetime_start = row.start_time
				_this.drc_usetime_end = row.end_time
				_this.drc_week_ids = row.week_cycle
				_this.drc_week_sign = _this.drc_week_ids.length > 0 && _this.drc_week_ids.length < _this.week_list.length;
				_this.drc_week_all = _this.drc_week_ids.length === _this.week_list.length;
				let week_txt = [];
				_this.week_list.forEach(_ => {
					_this.drc_week_ids.forEach(item => {
						if(_.id == item) {
							week_txt.push(_.name);
						}
					});
				});
				_this.drc_week_txt = week_txt.join(',');
				_this.showDrcList = false
				_this.showDrcEdit = true
            },
            drcShopChange(val) {
				new Promise(resolve => {
					this.drcRoomList(val, resolve)
				})
				this.drc_use_all_room = -1
				this.drc_room_txt = '';
				this.drc_room_item = [];
			},
			// 获取包厢号
			drcRoomList: function(shop_id, resolve) {
				const _this = this;

				Vue.axios.post('Shop/getAllRoomByArea', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.drc_room_arr = res.data.response.result;
						_this.drc_room_arr_det = [];
						res.data.response.result.forEach(_ => {
							_.room.forEach(item => _this.drc_room_arr_det.push(item))
						});
						resolve();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			// 点击选择包厢号
			drcRoomSelect: function(e) {
                this.drc_c_room_item = [...this.drc_room_item]
				this.showDrcEdit = false
				this.showDrcRoom = true
			},
			drcRoomDel() {
				this.drc_use_all_room = -1
				this.drc_room_txt = ''
				this.drc_room_item = []
			},
			// 全选
			drcRoomAll: function() {
				const _this = this;

				if(!_this.drc_room_all) { // 实现全选
					_this.drc_room_item = [];
					_this.drc_room_arr_det.forEach(item => {
						_this.drc_room_item.push(item.id);
					});
				} else { // 实现反选
					_this.drc_room_item = [];
				}
			},
			// 楼层全选/反选
			drcRoomFloor: function(id, index) {
				const _this = this;

				if(_this.drc_room_floor.indexOf(id) == -1) {
					_this.drc_room_arr[index].room.forEach(item => {
						if(_this.drc_room_item.indexOf(item.id) == -1) {
							_this.drc_room_item.push(item.id);
						}
					});
				} else {
					_this.drc_room_arr[index].room.forEach(item => {
						let index = '';
						index = _this.drc_room_item.indexOf(item.id);
						if(index != -1) {
							_this.drc_room_item.splice(index, 1);
						}
					});
				}
			},
			// 确定包厢
			drcRoomSave: function() {
				const _this = this;

				if(_this.drc_room_all) {
					_this.drc_room_txt = '全部'
					_this.drc_use_all_room = 1
				} else {
					let texts = [];
					_this.drc_room_arr_det.forEach(_ => {
						_this.drc_room_item.forEach(item => {
							if(_.id == item) {
								texts.push(_.name);
							}
						});
					});
					_this.drc_room_txt = texts.join(",");
					_this.drc_use_all_room = -1;
				}
				_this.showDrcEdit = true
				_this.showDrcRoom = false
			},
			// 返回
			drcRoomBack: function() {
				this.drc_room_item = [...this.drc_c_room_item]
				this.showDrcEdit = true
				this.showDrcRoom = false
			},
			drcUsetime: function() {
                const _this = this;

				_this.drc_hour_start = _this.drc_usetime_start.split(':')[0] || '00'
				_this.drc_minute_start = _this.drc_usetime_start.split(':')[1] || '00'
				_this.drc_hour_end = _this.drc_usetime_end.split(':')[0] || '00'
				_this.drc_minute_end = _this.drc_usetime_end.split(':')[1] || '00'
				layer.confirm('', {
					type: 1,
					skin: 'public-alert-skin',
					btn: ['确定', '取消'], // 按钮
					title: '使用时间',
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.drc_usetime_alert)
				}, function() {
					_this.drc_usetime_start = _this.drc_hour_start + ":" + _this.drc_minute_start
					_this.drc_usetime_end = _this.drc_hour_end + ":" + _this.drc_minute_end
					_this.drc_usetime_txt = _this.drc_usetime_start + " ~ " + _this.drc_usetime_end
					layer.closeAll();
				});
			},
			// 星期
            drcWeekSelect() {
                const _this = this;
                const c_week_ids = _this.drc_week_ids,
                    c_week_sign = _this.drc_week_sign,
                    c_week_all = _this.drc_week_all;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择星期', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.drc_week_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.drc_week_ids = c_week_ids;
                        _this.drc_week_sign = c_week_sign;
                        _this.drc_week_all = c_week_all;
                    }
                }, function() {
                    let arr = [];
                    _this.week_list.forEach(item => {
                        _this.drc_week_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.drc_week_txt = arr.join(',');
                    layer.closeAll();
                }, function() {
                    _this.drc_week_ids = c_week_ids;
                    _this.drc_week_sign = c_week_sign;
                    _this.drc_week_all = c_week_all;
                });
            },
            drcWeekDel() {
				this.drc_week_sign = false;
                this.drc_week_all = false;
				this.drc_week_ids = [];
            },
            drcWeekAll(val) {
                let ids = [];
				this.week_list.forEach(v => {
					ids.push(v.id);
				});
				this.drc_week_ids = val ? ids : [];
				this.drc_week_sign = false;
			},
			drcWeekChange(val) {
				const len = val.length;
				this.drc_week_sign = len > 0 && len < this.week_list.length;
				this.drc_week_all = len === this.week_list.length;
            },
            // 新增商品
            drcImgAdd: function() {
                this.drc_edit_form.keywords.push('')
            },
            // 删除商品
            drcImgDel: function(num) {
                this.drc_edit_form.keywords.splice(num, 1)
            },
            // 新增、修改
			drcEdit() {
				const _this = this;

				let url = 'Ipad/addSearchKeywordsData'
				let data = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": _this.drc_edit_form.shop_id,
							"listorder": _this.drc_edit_form.listorder,
							"all_room": _this.drc_use_all_room,
							"room_ids": _this.drc_room_item,
							"use_every_day": _this.drc_use_every_day,
							"start_date": _this.drc_usedate_start,
							"end_date": _this.drc_usedate_end,
							"start_time": _this.drc_usetime_start,
							"end_time": _this.drc_usetime_end,
							"week_cycle": _this.drc_week_ids,
							"keywords": _this.drc_edit_form.keywords
						}
					},
					"comment": ""
				};
				if(_this.drc_edit_id) {
					url = 'Ipad/editSearchKeywordsData'
					data.request.param.id = _this.drc_edit_id;
				}
				Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功');
						_this.drcTable(_this.drc_page);
						_this.showDrcList = true;
						_this.showDrcEdit = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			drcBackList() {
				this.showDrcList = true;
				this.showDrcEdit = false;
			},



            /*
             * 屏保设置
             */
            // 列表
			pbsTable: function(page) {
				const _this = this;

				_this.loading = true;
                _this.pbs_page = page
				Vue.axios.post('Ipad/getScreensaverList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.pbs_list_form.shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.pbs_total = Number(res.data.response.result.total);
						}
						_this.pbs_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 禁用启用
            pbsStatus(row) {
                const _this = this;

				layer.confirm('确定'+ (row.status == '1' ? '禁用' : '启用') +'吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('Ipad/updateScreensaverStatus', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": row.id,
                                "status": -row.status
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('操作成功');
							_this.pbsTable(_this.pbs_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 删除
			pbsDel(id) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('Ipad/delScreensaverData', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.pbsTable(_this.pbs_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 点击新增
			pbsAdd() {
                const _this = this
                _this.pbs_edit_id = ''
                _this.pbs_edit_tit = '新增屏保'
                _this.pbs_edit_form = {
                    shop_id: _this.shop_list[0].id,
					interval_time: '',
                    imgs_num: '0',
                    img: []
                }
                new Promise(resolve => {
					_this.pbsRoomList(_this.pbs_edit_form.shop_id, resolve)
				})
				.then(res => {
					_this.pbs_use_all_room = -1
					_this.pbs_room_txt = ''
					_this.pbs_room_item = []
				})
				_this.pbs_usedate_txt = ''
				_this.pbs_use_every_day = -1
                $(".pbs-usedate-everyday input").val("");
                $(".pbs-usedate-everyday input").prop("checked", false);
				_this.pbs_usedate_start = ''
                _this.pbs_usedate_end = ''
				_this.pbs_usetime_txt = ''
				_this.pbs_usetime_start = ''
				_this.pbs_usetime_end = ''
                _this.pbs_week_txt = ''
                _this.pbs_week_ids = []
                _this.pbs_week_sign = false
                _this.pbs_week_all = false
                _this.showPbsList = false
                _this.showPbsEdit = true
			},
			// 点击修改
			pbsModify(row) {
				const _this = this

                _this.pbs_edit_id = row.id
				_this.pbs_edit_tit = '修改屏保'
				_this.pbs_edit_form = {
					shop_id: row.shop_id,
					interval_time: row.interval_time,
                    imgs_num: row.img_num,
					img: []
				}
				new Promise(resolve => {
					_this.pbsRoomList(_this.pbs_edit_form.shop_id, resolve)
				}).then(res => {
                	_this.pbs_use_all_room = row.all_room
					_this.pbs_room_txt = row.room_names
					_this.pbs_room_item = row.room_ids.split(',')
				})
				_this.pbs_use_every_day = row.use_every_day
				_this.pbs_usedate_start = row.start_date
				_this.pbs_usedate_end = row.end_date
				if(row.use_every_day == 1) {
					$(".pbs-usedate-everyday input").val("1");
					$(".pbs-usedate-everyday input").prop("checked", true);
					_this.pbs_usedate_txt = '每天'
				} else {
					$(".pbs-usedate-everyday input").val("");
					$(".pbs-usedate-everyday input").prop("checked", false);
					_this.pbs_usedate_txt = row.start_date + '~' + row.end_date
				}
				_this.pbs_usetime_txt = row.start_time + '~' + row.end_time
				_this.pbs_usetime_start = row.start_time
				_this.pbs_usetime_end = row.end_time
				_this.pbs_week_ids = row.week_cycle
				_this.pbs_week_sign = _this.pbs_week_ids.length > 0 && _this.pbs_week_ids.length < _this.week_list.length;
				_this.pbs_week_all = _this.pbs_week_ids.length === _this.week_list.length;
				let week_txt = [];
				_this.week_list.forEach(_ => {
					_this.pbs_week_ids.forEach(item => {
						if(_.id == item) {
							week_txt.push(_.name);
						}
					});
				});
				_this.pbs_week_txt = week_txt.join(',');
                row.img.forEach((v, k) => {
					this.pbs_edit_form.img.push({'id': 'isflies' + (k + 1), 'src': v, status: '1'});
					this.pbsImgUpload('isflies' + (k + 1), k + 1);
				});
				_this.showPbsList = false
				_this.showPbsEdit = true
            },
            pbsShopChange(val) {
				new Promise(resolve => {
					this.pbsRoomList(val, resolve)
				})
				this.pbs_use_all_room = -1
				this.pbs_room_txt = '';
				this.pbs_room_item = [];
			},
			// 获取包厢号
			pbsRoomList: function(shop_id, resolve) {
				const _this = this;

				Vue.axios.post('Shop/getAllRoomByArea', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.pbs_room_arr = res.data.response.result;
						_this.pbs_room_arr_det = [];
						res.data.response.result.forEach(_ => {
							_.room.forEach(item => _this.pbs_room_arr_det.push(item))
						});
						resolve();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			// 点击选择包厢号
			pbsRoomSelect: function(e) {
                this.pbs_c_room_item = [...this.pbs_room_item]
				this.showPbsEdit = false
				this.showPbsRoom = true
			},
			pbsRoomDel() {
				this.pbs_use_all_room = -1
				this.pbs_room_txt = ''
				this.pbs_room_item = []
			},
			// 全选
			pbsRoomAll: function() {
				const _this = this;

				if(!_this.pbs_room_all) { // 实现全选
					_this.pbs_room_item = [];
					_this.pbs_room_arr_det.forEach(item => {
						_this.pbs_room_item.push(item.id);
					});
				} else { // 实现反选
					_this.pbs_room_item = [];
				}
			},
			// 楼层全选/反选
			pbsRoomFloor: function(id, index) {
				const _this = this;

				if(_this.pbs_room_floor.indexOf(id) == -1) {
					_this.pbs_room_arr[index].room.forEach(item => {
						if(_this.pbs_room_item.indexOf(item.id) == -1) {
							_this.pbs_room_item.push(item.id);
						}
					});
				} else {
					_this.pbs_room_arr[index].room.forEach(item => {
						let index = '';
						index = _this.pbs_room_item.indexOf(item.id);
						if(index != -1) {
							_this.pbs_room_item.splice(index, 1);
						}
					});
				}
			},
			// 确定包厢
			pbsRoomSave: function() {
				const _this = this;

				if(_this.pbs_room_all) {
					_this.pbs_room_txt = '全部'
					_this.pbs_use_all_room = 1
				} else {
					let texts = [];
					_this.pbs_room_arr_det.forEach(_ => {
						_this.pbs_room_item.forEach(item => {
							if(_.id == item) {
								texts.push(_.name);
							}
						});
					});
					_this.pbs_room_txt = texts.join(",");
					_this.pbs_use_all_room = -1;
				}
				_this.showPbsEdit = true
				_this.showPbsRoom = false
			},
			// 返回
			pbsRoomBack: function() {
				this.pbs_room_item = [...this.pbs_c_room_item]
				this.showPbsEdit = true
				this.showPbsRoom = false
			},
			pbsUsetime: function() {
                const _this = this;

				_this.pbs_hour_start = _this.pbs_usetime_start.split(':')[0] || '00'
				_this.pbs_minute_start = _this.pbs_usetime_start.split(':')[1] || '00'
				_this.pbs_hour_end = _this.pbs_usetime_end.split(':')[0] || '00'
				_this.pbs_minute_end = _this.pbs_usetime_end.split(':')[1] || '00'
				layer.confirm('', {
					type: 1,
					skin: 'public-alert-skin',
					btn: ['确定', '取消'], // 按钮
					title: '使用时间',
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.pbs_usetime_alert)
				}, function() {
					_this.pbs_usetime_start = _this.pbs_hour_start + ":" + _this.pbs_minute_start
					_this.pbs_usetime_end = _this.pbs_hour_end + ":" + _this.pbs_minute_end
					_this.pbs_usetime_txt = _this.pbs_usetime_start + " ~ " + _this.pbs_usetime_end
					layer.closeAll();
				});
			},
			// 星期
            pbsWeekSelect() {
                const _this = this;
                const c_week_ids = _this.pbs_week_ids,
                    c_week_sign = _this.pbs_week_sign,
                    c_week_all = _this.pbs_week_all;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择星期', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.pbs_week_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.pbs_week_ids = c_week_ids;
                        _this.pbs_week_sign = c_week_sign;
                        _this.pbs_week_all = c_week_all;
                    }
                }, function() {
                    let arr = [];
                    _this.week_list.forEach(item => {
                        _this.pbs_week_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.pbs_week_txt = arr.join(',');
                    layer.closeAll();
                }, function() {
                    _this.pbs_week_ids = c_week_ids;
                    _this.pbs_week_sign = c_week_sign;
                    _this.pbs_week_all = c_week_all;
                });
            },
            pbsWeekDel() {
				this.pbs_week_sign = false;
                this.pbs_week_all = false;
				this.pbs_week_ids = [];
            },
            pbsWeekAll(val) {
                let ids = [];
				this.week_list.forEach(v => {
					ids.push(v.id);
				});
				this.pbs_week_ids = val ? ids : [];
				this.pbs_week_sign = false;
			},
			pbsWeekChange(val) {
				const len = val.length;
				this.pbs_week_sign = len > 0 && len < this.week_list.length;
				this.pbs_week_all = len === this.week_list.length;
            },
            // 新增图片
            pbsImgsAdd: function() {
                if(this.pbs_edit_form.imgs_num == 10) {
                    layer.msg('屏保轮播图片最多只能设置10张');
                    return;
                }
                this.pbs_edit_form.imgs_num++;
                let id = 'isflies' + this.pbs_edit_form.imgs_num;
                this.pbs_edit_form.img.push({'id': id, 'src': require('../../assets/images/scrn_img_hp.png'), status: '-1'});
				this.pbsImgUpload(id, this.pbs_edit_form.imgs_num);
            },
            // 删除图片
            pbsImgsDel: function(num) {
                const _this = this;
                _this.pbs_edit_form.imgs_num--;
                _this.pbs_edit_form.img.splice(num, 1);
				$.each(_this.pbs_edit_form.img, function(k, v) {
					_this.pbs_edit_form.img[k].id = 'isflies' + (k + 1);
				});
			},
			// 上传图片
			pbsImgUpload: function(id, index) {
				let _this = this;
				let host = '',
					dir = '',
					file_name = '';

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: id, // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "Image files", extensions: "png" }
							],
							// max_file_size: '2mb', // 文件大小限制
							prevent_duplicates: true // 不允许选取重复文件
						},
						// resize: {
						// 	width: 527,
						// 	height: 296
						// },
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 文件上传前触发
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
								// 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'Setting'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host;
										dir = res.data.response.data.dir;
										file_name = res.data.response.data.file_name;
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': res.data.response.data.accessid,
											'policy': res.data.response.data.policy,
											'signature': res.data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

										// 上传文件
										uploader.start();
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
							},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
								_this.pbs_edit_form.img[index - 1].status = '1';
								_this.pbs_edit_form.img[index - 1].src = host + "/" + dir + file_name;
								layer.msg('上传成功');
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传png文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
								}
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
			},
            // 新增、修改
			pbsEdit() {
				const _this = this;

                let img = [];
				_this.pbs_edit_form.img.forEach(v => {
					if(v.status == '1') {
						img.push(v.src);
					}
				});
				let url = 'Ipad/addScreensaverData'
				let data = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": _this.pbs_edit_form.shop_id,
							"all_room": _this.pbs_use_all_room,
							"room_ids": _this.pbs_room_item,
							"use_every_day": _this.pbs_use_every_day,
							"start_date": _this.pbs_usedate_start,
							"end_date": _this.pbs_usedate_end,
							"start_time": _this.pbs_usetime_start,
							"end_time": _this.pbs_usetime_end,
							"week_cycle": _this.pbs_week_ids,
							"interval_time": _this.pbs_edit_form.interval_time,
							"img": img
						}
					},
					"comment": ""
				};
				if(_this.pbs_edit_id) {
					url = 'Ipad/editScreensaverData'
					data.request.param.id = _this.pbs_edit_id;
				}
				Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功');
						_this.pbsTable(_this.pbs_page);
						_this.showPbsList = true;
						_this.showPbsEdit = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			pbsBackList() {
				this.showPbsList = true;
				this.showPbsEdit = false;
			},

            /*
             * 首页导航功能设置
             */
            // 列表
            getNavSetList: function(page) {
                const _this = this;

                _this.loading = true;
                _this.nav_page = page
                Vue.axios.post('Ipad/getNavSetList', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        if(page == 1) {
                            _this.nav_total = Number(res.data.response.result.total);
                        }
                        _this.nav_list = res.data.response.result.rows;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 点击列表“修改”
            onNavEditClick(row) {
                this.getNavSetDetail(row.shop_id)
                if (this.nav_set_uploaders.length > 0) {
                    this.nav_set_uploaders.forEach(item => {
                        item.destroy()
                    })
                    this.nav_set_uploaders = []
                }
                this.uploadNavSetImg("fun-img")
                this.uploadNavSetImg("supermarket-img")
                this.uploadNavSetImg("personnel-book-img")
            },

            // 获取设置详情
            getNavSetDetail(shop_id) {
                let _this = this
                Vue.axios.post('Ipad/getNavSet', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.nav_set_form = res.data.response.result
                        _this.showNavSetPanel = true
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 上传导航设置图片
            uploadNavSetImg(id) {
                let _this = this;
                let host = '',
                    dir = '',
                    file_name = '';

                // 实例化一个plupload上传对象
                let uploader = new plupload.Uploader({
                    browse_button: id, // 选择文件id
                    filters: {
                        mime_types: [ // 文件格式限制
                            { title: "Image files", extensions: "jpg,png" }
                        ],
                        // max_file_size: '2mb', // 文件大小限制
                        prevent_duplicates: true // 不允许选取重复文件
                    },
                    multi_selection: false, // 单选
                    url: './', // OSS地址
                    init: {
                        // 文件上传前触发
                        BeforeUpload: function(up, file) {},
                        // 文件选择完毕触发
                        FilesAdded: function(up, files) {
                            // 获取签名
                            Vue.axios.post('publicData/api_getOssSignature', {
                                "header": Vue.request_header,
                                "request": {
                                    "version": Vue.version,
                                    "param": {
                                        "file": files[0].name,
                                        "path": 'Setting'
                                    }
                                },
                                "comment": ""
                            })
                            .then(res => {
                                if(res.data.response.result_code == "true") {
                                    host = res.data.response.data.host;
                                    dir = res.data.response.data.dir;
                                    file_name = res.data.response.data.file_name;
                                    const new_params = {
                                        'key': dir + file_name,
                                        'OSSAccessKeyId': res.data.response.data.accessid,
                                        'policy': res.data.response.data.policy,
                                        'signature': res.data.response.data.signature,
                                        'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
                                    };
                                    up.setOption({
                                        'url': host,
                                        'multipart_params': new_params
                                    });

                                    // 上传文件
                                    uploader.start();
                                } else {
                                    Vue.timeoutfun(data.response.result_status, _this);
                                    layer.msg(data.response.error_msg);
                                }
                            })
                            .catch(err => {
                                layer.msg("出错啦");
                            });
                        },
                        // 文件上传成功触发
                        FileUploaded: function(up, file, data) {
                            if (id == 'fun-img') {
                                _this.nav_set_form.fun.img_url = host + "/" + dir + file_name;
                            }else if(id == 'supermarket-img') {
                                _this.nav_set_form.supermarket.img_url = host + "/" + dir + file_name;
                            }else if(id == 'personnel-book-img') {
                                _this.nav_set_form.personnel_book.img_url = host + "/" + dir + file_name;
                            }
                            layer.msg('上传成功');
                        },
                        // 错误提示
                        Error: function(up, err) {
                            if(err.code == -600) {
                                layer.msg('请选择2mb以内的文件');
                            } else if (err.code == -601) {
                                layer.msg('只允许上传png文件');
                            } else if (err.code == -602) {
                                layer.msg('这个文件已经上传过一遍了');
                            } else {
                                layer.msg(err.response);
                            }
                        }
                    }
                });
                // 初始化
                uploader.init();
                _this.nav_set_uploaders.push(uploader)
            },

            // 保存导航设置
            submitNavSet() {
                let _this = this
                Vue.axios.post('Ipad/upNavSet', {
                    "header": Vue.request_header,
                    "request": {
                        "param": _this.nav_set_form
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg("保存成功！")
                        _this.showNavSetPanel = false
                        _this.getNavSetList(_this.nav_page)
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

        }
    }
</script>
<style lang="less" scoped>
    .pos-title {
        margin: 0 0 30px;
        text-align: center;
    }
	.select-goods-wrap {
        display: none;
    }
	.dtj-edit {
        .el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
            .dtj-usedate-wrap {
                position: relative;
            }
            .dtj-usedate-main {
                width: 400px;
            }
		}
		.dtj-edit-goods {
			width: 400px;
			padding: 20px;
			margin: 0 0 30px;
			background: #f5f5f5;
			p {
				float: left;
				margin-right: 20px;
				color: #f00;
			}
			i {
				color: #409eff;
				font-size: 40px;
				cursor: pointer;
			}
			img {
				clear: both;
				display: block;
				width: 114px;
				height: 114px;
				margin: 0 0 20px;
				cursor: pointer;
			}
			.el-input {
				width: 230px;
			}
		}
    }
	.drc-edit {
        .el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
            .drc-usedate-wrap {
                position: relative;
            }
            .drc-usedate-main {
                width: 400px;
            }
		}
		.drc-edit-goods {
			margin: 0 0 20px;
			i {
				vertical-align: bottom;
				color: #409eff;
				font-size: 40px;
				cursor: pointer;
			}
		}
    }

    .pbs-edit {
        .el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
            .pbs-usedate-wrap {
                position: relative;
            }
            .pbs-usedate-main {
                width: 400px;
            }
		}
        .pbs-imgs {
            h3 {
                line-height: 40px;
            }
            li {
                position: relative;
                float: left;
                width: 180px;
                height: 101px;
                margin: 30px 30px 0 0;
                .pbs-imgs-del {
                    position: absolute;
                    right: -11px;
                    top: -11px;
                    cursor: pointer;
                    z-index: 1999;
                }
                .pbs-imgs-item {
                    display: block;
                    width: 180px;
                    height: 101px;
                    cursor: pointer;
                }
                .pbs-imgs-add {
                    cursor: pointer;
                }
            }
        }
    }

    .nav-set {
        .img-wrapper {
            position: relative;
            width: 342px;
            height: 113px;
            img {
                width: 100%;
                height: 100%;
            }
            .el-button {
                position: absolute;
                right: -200px;
                bottom: 15px;
                transform: translateX(-50%);
            }
            .tip {
                position: absolute;
                right: -190px;
                top: 25px;
            }
        }
    }
</style>